import {CommonService} from '../../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  templateUrl: './super-market-key-account-dialog.component.html'
})
export class SuperMarketKeyAccountDialogComponent implements OnInit {
  edit: boolean;
  keyAccount: any;
  title: string;
  payerID: any;
  keyAccountName: string;
  salesGroupID: string;

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<SuperMarketKeyAccountDialogComponent>) {
    this.title = 'Προσθήκη νέας γραμμής';
  }

  public async ngOnInit(): Promise<any> {
  }

  close(item?) {
    this.matDialogRef.close(item);
  }

  submitSMKeyAccount() {
    const model = {
      payer_id: this.payerID,
      key_account_name: this.keyAccountName,
      sales_group_id: this.salesGroupID
    };
    this.close(model);
  }

  formInvalid(): boolean {
    return !this.payerID || !this.keyAccountName || !this.salesGroupID;
  }
}
